import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { paymentsFetch } from "./paymentsFetch";

const EditBooingPayment = async (body: any, paymentId: string) => {
  return paymentsFetch(`/api/payments/manual/${paymentId}`, "PATCH", body);
};

export const useEditBookingPaymentMutation = (bookingId: string) => {
  const queryClient = useQueryClient();
  const { toast, dismiss } = useToast();

  return useMutation({
    mutationFn: (data: { body: any; paymentId: string; toastId: any }) => {
      return EditBooingPayment({ ...data.body, bookingId }, data.paymentId);
    },
    onSuccess: (_, variables) => {
      dismiss(variables.toastId);

      toast({
        title: "Success",
        description: "Payment edited successfully!",
        variant: "default",
      });

      queryClient.invalidateQueries({ queryKey: ["paymentsData", bookingId] });
      queryClient.invalidateQueries({ queryKey: ["paymentLogsData", bookingId] });
      queryClient.invalidateQueries({ queryKey: ["paymentScheduleCustomerData", bookingId] });
      queryClient.invalidateQueries({ queryKey: ["paymentScheduleOperatorData", bookingId] });
    },
    onError: (error: any, variables) => {
      dismiss(variables.toastId);
      toast({
        title: "Error",
        description: error.message || "Failed to edit booking payment!",
        variant: "destructive",
      });
    },
  });
};
